import React from "react";
import { Component } from "react";
import ButtonIcon from '../../../button';
import UserSummaryDetails from "./user-summary-details/user-summary-details.component";
import SummaryHeader from "./user-summary-header/user-summary-header.component";
class SummaryDetails extends Component {
    render(){
        return(
            <div>
                <SummaryHeader />
                <UserSummaryDetails />
            </div>
        )
    }
}

export default SummaryDetails;